"use client";

import { useRouter } from "../../../i18n/navigation";
import { useLocale } from "next-intl";

export default function LanguageSwitcher({ onLanguageChange }: { onLanguageChange: () => void }) {
    const router = useRouter();
    const locale = useLocale();

    const switchLocale = (nextLocale: "en" | "de") => {
        router.replace({ pathname: "/" }, { locale: nextLocale });
        onLanguageChange();
        router.refresh();
    };

    return (
        <div className="flex items-center gap-6">
            <button
                className={`cursor-pointer flex gap-2 m-body-l  md:d-body-l ${locale === "de" ? "items-center" : "items-end"}`}
                onClick={() => switchLocale("de")}
                aria-label="Sprache auf Deutsch umstellen"
            >
                {locale === "de" ? (
                    <img
                        src="/icon_circle.svg"
                        className="w-8 h-8"
                        alt="Aktiv: Deutsch ausgewählt"
                    />
                ) : (
                    <img
                        className="mb-1.5"
                        width="16"
                        height="2"
                        src="/icon_line.svg"
                        alt="Sprache auf Deutsch umstellen"
                    />
                )}
                de
            </button>
            <button
                className={`cursor-pointer flex gap-2 m-body-l md:d-body-l ${locale === "en" ? "items-center" : "items-end"}`}
                onClick={() => switchLocale("en")}
                aria-label="Switch language to English"
            >
                {locale === "en" ? (
                    <img src="/icon_circle.svg" alt="Active: English selected" />
                ) : (
                    <img className="mb-1.5" src="/icon_line.svg" alt="Switch language to English" />
                )}
                en
            </button>
        </div>
    );
}
